import { jsx as _jsx } from "react/jsx-runtime";
import { fluxCardSurface } from "../flux/variants.js";
export function Card({ className = "", children, ...rest }) {
    return (_jsx("div", { className: [fluxCardSurface, className].join(" "), ...rest, children: children }));
}
export function CardHeader({ className = "", children, ...rest }) {
    return (_jsx("div", { className: [
            "flex flex-col items-stretch gap-2 border-b border-zinc-100 px-4 py-3 sm:px-5 sm:py-3.5",
            className,
        ].join(" "), ...rest, children: children }));
}
export function CardTitle({ className = "", children, ...rest }) {
    return (_jsx("h3", { className: ["text-sm font-medium text-zinc-800 sm:text-[0.9375rem]", className].join(" "), ...rest, children: children }));
}
export function CardBody({ className = "", children, ...rest }) {
    return (_jsx("div", { className: ["px-4 py-3 sm:px-5 sm:py-4", className].join(" "), ...rest, children: children }));
}
export function CardFooter({ className = "", children, ...rest }) {
    return (_jsx("div", { className: ["border-t border-zinc-100 px-4 py-3 sm:px-5 sm:py-3.5", className].join(" "), ...rest, children: children }));
}
